import axios from "./http_v2";
import user from "./user/index.js";
import active from "./active/index.js";
import enterpriseApi from "./enterprise/index.js";

import market from "./market/index.js";
import email from "./_email.js";

import content from "./content/index.js";
import channel from "./channel/index.js";
import wx from "./wechat/index.js";
import common from "./common/index.js";
import autoweb from "./autoweb/index.js";
import clue from "./clue/index.js";
import website from "./website/index.js";
import form from "./form/index.js";
export default {
  user, //用户中心
  content, //内容中心
  active, //活动模块
  market, // 营销中心
  email, // 邮件 Api
  channel, //渠道中心
  wx, // 微信（小程序、公众号）
  autoweb, // 自助建站（移动端自搭建页面）
  clue, //线索
  website, //网站
  form, //表单
  common,
  enterpriseApi, //组织账号管理
  // 租户管理员
  tenant: {
    // 租户管理员登录接口
    login: (params) => {
      return axios.post("opservice/tenant/login", params);
    },
    yhtLogin: (params) => {
      return axios.get("/opservice/userlogin/ykjcode/login", params);
    },
    // 当前登录租户管理员信息
    info: (params) => {
      return axios.get("opservice/tenant/current", params);
    },
    // 获取当前登录人的加密手机号
    mobile: (params) => {
      return axios.get("opservice/tenant/security/current/mobile", params);
    },
    // 获取短信验证码（用户名+手机号）
    getCodeByUser: (params) => {
      return axios.post("opservice/enterpriseadmin/findpwd", params);
    },
    // 获取短信验证码（用户名+手机号+密码）
    getCodeByUserPwd: (params) => {
      return axios.post("opservice/enterpriseadmin/findpwd/verify", params);
    },
    // 根据短信验证码重置密码
    resetPwd: (param) => {
      return axios.post("opservice/enterpriseadmin/resetpwd", param);
    },
    // 检查手机号是否已注册
    existsMobile: (params) => {
      return axios.post("opservice/regist/existsmobile", params);
    },
    // 注册校验手机验证码是否正确
    existsCode: (params) => {
      return axios.post("opservice/regist/iscode", params);
    },
    //密码人机校验
    getcode: "marketcenter/api/sms/v2/code/with/captcha/html/page",
  },

  home: {
    tongji: (id) => {
      let idStr = id ? "/" + id : "";
      if (idStr) {
        return axios.get("activityservice/activityCount/count" + idStr, {});
      }
    },
    data: (param) => {
      return axios.post("activityservice/activitycountvto/countvto2", param);
    },

    del: (params) => {
      return axios.get("opservice/tenant/update/delete", params);
    },

    // 活动相关统计
    activity: (param) => {
      return axios.post("activityservice/homestats/activity/overall", param);
    },
    // 文章
    article: (param) => {
      return axios.post("opservice/homestats/article/overall", param);
    },
    //视频
    video: (param) => {
      return axios.post("activityservice/homestats/video/overall", param);
    },
    //落地页
    website: (param) => {
      return axios.post("opservice/homestats/website/overall", param);
    },
    //问卷
    form: (param) => {
      return axios.post("formbuilder/homestats/form/overall", param);
    },
    //资料
    doc: (param) => {
      return axios.post("opservice/homestats/doc/overall", param);
    },
    //表单
    applyform: (param) => {
      return axios.post("formbuilder/homestats/applyform/overall", param);
    },
    // 线索统计
    clue: (param) => {
      return axios.post("formbuilder/homestats/clue/overall", param);
    },
    // 营销任务统计
    taskjob: (param) => {
      return axios.post("opservice/homestats/taskjob/overall", param);
    },
    // 公司统计
    dwcompany: (param) => {
      return axios.post("opservice/homestats/dwcompany/overall", param);
    },
    // 用户统计
    user: (param) => {
      return axios.post("opservice/homestats/user/overall", param);
    },
    // 短信使用统计
    sms: (param) => {
      return axios.post("activityservice/activitycountvto/sms/count", param);
    },
    // 邮件使用统计
    email: (param) => {
      return axios.post("activityservice/activitycountvto/mail/count", param);
    },
    // 管理员统计
    enterpriseadmin: (param) => {
      return axios.post("opservice/homestats/enterpriseadmin/overall", param);
    },
    // 在线人数
    events: (param) => {
      return axios.post("searchservice/official/website/count/user/online", param);
    },
    // PV/UV
    pvuv: (param) => {
      return axios.post("searchservice/official/website/agges/pvuv", param);
    },
    // 峰值在线人数
    peek: (param) => {
      return axios.post("searchservice/official/website/agges/peek", param);
    },
    // TOP10来源网站
    top10: (param) => {
      return axios.post("searchservice/official/website/agges/top10/rf", param);
    },
    // TOP10业务页面
    top10Title: (param) => {  
      return axios.post("searchservice/official/website/agges/top10/title", param);
    }
  
  },

  /*公共接口*/
  basic: {
    leftMenuList: (params) => {
      // 左侧导航栏
      return axios.get("opservice/tenant/security/current/menu/left", params);
    },
    getmenu: (params) => {
      // 顶部导航栏
      return axios.get("opservice/tenant/security/current/menu/top", params);
    },
    getCity: (params) => {
      //获取城市数据
      return axios.get("opservice/opbasedocarea/allcity.json", params);
    },
    getCity2: (params) => {
      //获取城市数据
      return axios.get("opservice/opbasedocarea/allcityAbroad.json", params);
    },
    getLabel: (data) => {
      // 获取所有的系统标签
      return axios.post("opservice/opbasedoclabel/list", data);
    },
    // 获取所有行业
    getAllIndustry: (params) => {
      return axios.get("content-service/sys_industry/list", params);
    },
    // 获取所有领域
    getAllField: (params) => {
      return axios.get("content-service/sys_field/list", params);
    },

    // 获取协作管理员
    getAllAdmin: (data) => {
      return axios.post("opservice/enterpriseadmin/paged_all", data);
    },
    // 在线人数
    getUserOnline: (data) => {
      return axios.post("opservice/homestats/user/online", data);
    },
    // 生成http短连接服务
    generateShortUrl(params) {
      return axios.post("https://mk-api.yybip.com/y/generatecode", params);
    },

    downloadImage(url) {
      return axios.get(url, {});
    },
  },

  // 全员营销
  qyyx: {
    shareLog: (params) => {
      return axios.post("marketcenter/share/log/detail", params);
    },
    activeShareRankingOrg: (params) => {
      return axios.post("marketcenter/share/rank?aid=" + params.aid, params);
    },
    activeShareRankingPerson: (params) => {
      return axios.post("marketcenter/share/person/rank", params);
    },
    exportShareLogExcel: "marketcenter/share/log/",
    exportShareLog: (params) => {
      return axios.post("marketcenter/share/log/excel", params);
    },
  },

  upload: {
    // 上传图片api地址 uploadImg
    fileUrl: process.env.VUE_APP_API_ROOT + "opservice/ophonoredguest/savefile",

    // 本地文件上传
    file: (data) => {
      return axios.post("opservice/ophonoredguest/savefile", data);
    },

    // base64上传图片
    base64: (data) => {
      let base64Params = {
        prefix: "base64image",
        suffix: ".png",
        base64: data.replace("data:image/png;base64,", ""),
      };
      return axios.post(
        "opservice/ophonoredguest/base64/savefileinfo",
        base64Params
      );
    },

    // 远程图片转存MK
    remoteUrl: (data) => {
      let remoteUploadApiUrl = "content-service/cnt_article/xm/reptile";
      let dataParams = [
        {
          "source[]": data,
        },
      ];
      dataParams.forEach((item, index) => {
        remoteUploadApiUrl +=
          (index == 0 ? "?" : "&") + "source[]=" + item["source[]"];
      });
      return axios.post(remoteUploadApiUrl, dataParams);
    },
  },

  // 菜单管理
  menu: {
    tree: (params) => {
      return axios.get("opservice/tree?rang=tenant", params);
    },
    save: (params) => {
      return axios.post("opservice/save", params);
    },
    delete: (params) => {
      return axios.post("opservice/delete", params);
    },
  },
};
